import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Schoolpicnicorganiserinpimprichichwad() {



    const cardData =
    {
        keyword: 'School Picnic Organisers in Pimpri Chinchwad',
        heading: 'Anand Krushi Paryatan Kendra: School Picnic Organisers in Pimpri Chinchwad',
        headingDescription: 'Looking for reliable and student-friendly school picnic organisers in Pimpri Chinchwad? Anand Krushi Paryatan Kendra, located just 55 km from the city in Morachi Chincholi, is a trusted choice for schools across PCMC. With a 40-acre eco-friendly campus and expert team, this agri-tourism center specializes in safe, educational, and fun-filled school picnics. As experienced school picnic organisers in Pimpri Chinchwad, the center offers complete day packages including transportation coordination, meals, activity planning, and on-site supervision. Students enjoy a wide range of rural and recreational activities like bullock cart and tractor rides, boating, swimming, horse riding, and rain dance. Cultural shows such as puppetry and magic shows enhance the learning experience in an engaging way.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',
topPlaces: [
  {
    "title": "Anand Krushi Paryatan – Managed School Picnics",
    "description": "Located near Morachi Chincholi (about 55 km from Pimpri Chinchwad), Anand Krushi is a preferred school picnic partner offering pre-arranged, staff-assisted packages. Activities include peacock spotting, tractor & bullock-cart rides, rain dance, splash pool, traditional games, puppet/magic shows, and wholesome Maharashtrian meals. Organisers provide group coordination, student safety, and activity schedules tailored by age group. Free entry and meals for teachers make it school-friendly."
  },
  {
    "title": "Mhalasakant Agritourism – School Tour Specialists",
    "description": "Popular among schools in PCMC, Mhalasakant Agro offers structured one-day programs with guided farming, games, and adventure activities like ziplining, rope climbing, archery, and magic shows. Includes breakfast, unlimited lunch, and high tea. The campus is secure, with staff assigned for crowd management and student movement. Customised packages available for kindergarten to secondary level."
  },
  {
    "title": "Krushnankur Agro Tourism – Near Alandi",
    "description": "A convenient option for PCMC schools, Krushnankur (around 25–30 km away) is known for clean, educational rural tourism. Children can participate in farming activities, bullock-cart rides, diya painting, and story sessions. Staff arrange games like musical chairs, spoon races, and sack races. The campus has shaded seating and dedicated restrooms for children and teachers."
  },
  {
    "title": "Jay Malhar Agro Tourism – Group Activity Hub",
    "description": "With over 45 activities on-site, Jay Malhar caters to large school groups from PCMC and Pune. Kids enjoy the splash pool, rain dance, rope games, trampoline, and traditional village games. Safety staff and coordinators help manage large crowds. Pre-fixed meal timings, separate teacher rest zones, and school pickup coordination (if needed) make this a reliable organiser for all-day school trips."
  },
  {
    "title": "Mauli Krushi Paryatan – Educational + Fun Day",
    "description": "This organiser focuses on farm learning combined with child-safe fun. School groups enjoy animal feeding, seed planting, cow milking, and composting sessions, followed by outdoor games and mini rain dance. Especially suited for schools wanting value-based, hands-on experiences for younger children. Well-planned food schedule and staff-assisted game zones make it a low-hassle option for teachers."
  }
],




  "services": [
    {
      "name": "Nisargshala Eco-Trip Organisers",
      "description": "Specialize in one-day eco-picnics near Torna–Rajgad (~70 km from Pune), offering guided nature walks, river play, plant ID sessions, and team-building modules tailored for ages 6–9 years." 
    },
    {
      "name": "Avani Agro Tourism (Kalus, PCMC)",
      "description": "Day trips focused on agro-education—crop cultivation techniques, animal-feeding, compost workshops—with full coordination, certified guides, and school-centric packages." 
    },
    {
      "name": "Raikar Farms (Kamshet)",
      "description": "Educational farm-field trips featuring organic farming, animal husbandry, solar/wind energy demos, bullock cart/tractor rides, camping, treasure hunts, and large-group accommodations." 
    },
    {
      "name": "Prathamesh/Go Crazy Resorts",
      "description": "Adventure-packed picnics near Khed Shivapur, offering 35+ activities—rope courses, rain dance, adventure games—with meals and transport coordination starting ₹500–1,000/student." 
    },
    {
      "name": "Konkankanya Agritourism",
      "description": "Hurda, aamras, and school-picnic packages with swimming, boating, DJ rain-dance, bullock-cart & tractor rides, adventure games—priced ₹350–600 per student." 
    },
    {
      "name": "Nature Nestt Agro Tourism (Uruli Kanchan)",
      "description": "One-day school picnics with farm walks, rain‑dance, swimming, boating, crafts, animal interaction, and full meals—rated ₹600–900 per child." 
    }
  ],
  "tableData": [
    ["Nisargshala Eco‑Trip Organisers", "Avani Agro Tourism (PCMC)"],
    ["Raikar Farms (Kamshet)", "Prathamesh/Go Crazy Resorts"],
    ["Konkankanya Agritourism", "Nature Nestt Agro Tourism"],
    ["", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Pune Bus Hire",
    "WhyChoosedescription": "Pune Bus Hire offers reliable bus rental services for school trips in Pimpri Chinchwad. They provide AC and non-AC buses with experienced drivers, ensuring safe and comfortable transportation for students to various picnic spots, including Morachi Chincholi."
  },
  {
    "WhyChooseheading": "PAVANA EVENTS",
    "WhyChoosedescription": "PAVANA EVENTS is a party and event planning company based in Pimpri Chinchwad. They specialize in organizing school picnics, offering services such as venue selection, catering, and entertainment, tailored to the needs of educational institutions."
  },
  {
    "WhyChooseheading": "JOL Events & Entertainments",
    "WhyChoosedescription": "JOL Events & Entertainments, located in Pimple Gurav, Pune, provides event management services for school picnics. They offer a range of services including decor, entertainment, and logistics, ensuring a memorable outing for students."
  }
]

































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Who organizes school picnics in Pimpri‑Chinchwad?',
    answer: 'Leading organizers include agro‑tourism resorts like Pawar Agro Resort (near Khed) and local event planners (e.g., Wonderland Event Planner, Pratibha Event) who specialize in managing educational day trips.',
  },
  {
    id: 'FAQ2',
    question: 'What services do these organizers provide?',
    answer: 'They offer comprehensive planning including transport coordination, activity scheduling (farm tours, nature walks, educational sessions), meals, safety supervision, and first‑aid support.',
  },
  {
    id: 'FAQ3',
    question: 'Can they handle large school groups?',
    answer: 'Yes, venues like Pawar Agro Resort can accommodate over 1,200 students, while local organizers arrange buses and supervision for groups of 50–200 children.',
  },
  {
    id: 'FAQ4',
    question: 'What kind of activities are included?',
    answer: 'Typical activities include farm walks, crop and animal care demos, traditional games, tractor rides, and eco‑education workshops that align with school curriculum goals.',
  },
  {
    id: 'FAQ5',
    question: 'Are meals and snacks included?',
    answer: 'Yes, organizers typically arrange nutritious, farm‑fresh vegetarian meals—breakfast, lunch, and evening snacks—tailored to dietary requirements.',
  },
  {
    id: 'FAQ6',
    question: 'What safety measures are in place?',
    answer: 'Organizers ensure student safety with trained staff supervision, designated play areas, first‑aid facilities, and adherence to school permission protocols :contentReference[oaicite:0]{index=0}.',
  },
  {
    id: 'FAQ7',
    question: 'Do they arrange transportation?',
    answer: 'Yes, most organizers coordinate buses or vans for pick‑up/drop‑off within Pimpri‑Chinchwad and Pune, ensuring smooth logistics.',
  },
  {
    id: 'FAQ8',
    question: 'How much does a school picnic cost?',
    answer: 'Prices typically range from ₹400–800 per student depending on location, group size, activities, meals, and transport options.',
  },
  {
    id: 'FAQ9',
    question: 'How far in advance should we book?',
    answer: 'Schools are advised to book at least 2–4 weeks in advance, especially during peak seasons and safe-trip regulation periods :contentReference[oaicite:1]{index=1}.',
  },
  {
    id: 'FAQ10',
    question: 'How can I contact picnic organizers in Pimpri‑Chinchwad?',
    answer: 'You can reach out via websites, WhatsApp, or phone numbers of agro‑tourism resorts like Pawar Agro Resort (+91 82828 23334) :contentReference[oaicite:2]{index=2} or local event planners listed on Sulekha.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Kavita Deshpande, Teacher, Pimpri',
    feedback: "The picnic organized at Pawar Agro Resort was excellent—well‑structured, educational, and the children were fully engaged throughout the day.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Sandeep Malhotra, Principal, PCMC',
    feedback: "Professional coordination by local planners made the entire experience seamless. Transport, activities, and food arrangements worked perfectly.",
    rating: 5,
  },
];




































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const schoolPicnicPCMSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "School Picnic Organisers in Pimpri Chinchwad - Anand Krushi Paryatan Kendra",
  "url": "https://morachichincholi.in/school-picnic-pimpri-chinchwad",
  "description": "Top school picnic organisers near Pimpri Chinchwad offering full-day educational and nature-based trips for students with transport, food, guided activities, and agro-tourism exposure.",
  "sameAs": "https://morachichincholi.in/",
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Customer Service",
    "telephone": "+91-12345-67890",
    "email": "info@morachichincholi.in"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pimpri Chinchwad, Pune"
  },
  "serviceType": [
    "School picnic planning",
    "Day trip coordination",
    "Student-friendly nature tours",
    "Farm and wildlife visits",
    "Group activity planning for schools"
  ]
};



    return (
        <div>
<Helmet>
  <title>School Picnic Organisers in Pimpri Chinchwad | Educational Day Trips & Nature Tours</title>
  <meta 
    name="description" 
    content="Experienced school picnic organisers in Pimpri Chinchwad offering full-day nature and adventure trips for students. Packages include transportation, food, agro-tourism, and certified safety arrangements." 
  />
  <meta 
    name="keywords" 
    content="Local school picnic agencies, School outing experts near PCMC, Day trips with full coordination, Safe picnic plans for schools, Fun with learning packages, Nature and adventure day planners, Transportation and food inclusive packages, Nearby picnic locations managed, Teachers’ support and guides, Custom plans for school standards, Farm and wildlife exposure trips, Budget picnic arrangements, Group game organisers, Certified providers for student outings, Agro-tourism tie-ups for schools" 
  />
  <script type="application/ld+json">
    {JSON.stringify(schoolPicnicPCMSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/41.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Schoolpicnicorganiserinpimprichichwad;